import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { handleLogout } from "./authActions";
import {
  registerAuthSessionHandler,
  unregisterAuthSessionHandler,
} from "./authSessionHandler";
import { savePostLoginRedirect } from "@helpers/loginRedirect";
import { warning } from "@alert";

/** 後端因封存或權限變更撤銷登入時回傳的錯誤代碼 */
const SESSION_REVOKED = "SESSION_REVOKED";

function getHashRouteParts() {
  const hash = window.location.hash || "";
  const match = hash.match(/^#(\/[^?]*)(\?.*)?$/);
  return {
    pathname: match?.[1] || "/",
    search: match?.[2] || "",
  };
}

export function AuthSessionHandler() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    registerAuthSessionHandler({
      onUnauthorized: ({ code } = {}) => {
        const { pathname, search } = getHashRouteParts();
        handleLogout(dispatch);
        if (pathname !== "/") {
          savePostLoginRedirect(pathname, search);
          navigate("/", { replace: true });
        }
        if (code === SESSION_REVOKED) {
          warning(1, "已登出", "您的帳號權限已變更，請重新登入", "確認");
        }
      },
    });

    return unregisterAuthSessionHandler;
  }, [dispatch, navigate]);

  return null;
}
